export default {
  "wt-tooltip": "_wt-tooltip_tjjqk3_11",
  "fadein": "_fadein_tjjqk3_1",
  "wt-tooltip__content": "_wt-tooltip__content_tjjqk3_20",
  "wt-tooltip_size_s": "_wt-tooltip_size_s_tjjqk3_41"
};